import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";
import { RoleSelection } from "@common/roleSelection";
import { Props } from "./types";
import { Columns } from "./columns";
import styles from "./styles.scss";

function Form({ formData, projectId, usedRoles, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h2 className={styles.label}>{t("wbsConfiguration.name")}</h2>
        <TextInput
          placeholder={t("wbsConfiguration.name")}
          value={formData.name}
          input={(name) => edit({ ...formData, name })}
        />
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>{t("wbsConfiguration.roles")}</h2>
        <div className={styles.roleSelection}>
          <RoleSelection
            selectedRoleIds={formData.roles}
            rolesToExclude={usedRoles}
            placeholder={t("wbsConfiguration.roles")}
            select={(role) =>
              edit({
                ...formData,
                roles: [...formData.roles, role.name],
              })
            }
            unSelect={(role) =>
              edit({
                ...formData,
                roles: formData.roles.filter(
                  (id) => id !== role.uuid && id !== role.name,
                ),
              })
            }
          />
        </div>
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>{t("wbsConfiguration.columns")}</h2>
        <Columns projectId={projectId} formData={formData} edit={edit} />
      </div>
    </div>
  );
}

export { Form };
